const SignaturePad = require('signature_pad').default
const axios = require('axios')

const is = require('../plugins/helper/is')
const { listen } = require('../plugins/event/listen')
const Swal = require('../plugins/sweet/Alert').default

const signatureCanvas = document.getElementById('signature_canvas')
const signatureContainer = document.getElementById('signature_container')
const buttonClearSignature = document.getElementById('button_clear_signature')
const buttonSendSignature = document.getElementById('button_save_signature')
let signaturePad = null

try {
  if (is.node(signatureCanvas)) {
    const options = {
      get passive() {
        return false
      },
    }
    const getWidth = () => {
      return (is.node(signatureContainer)) ? signatureContainer.clientWidth : screen.width
    }
    const getHeight = () => {
      return (is.node(signatureContainer)) ? signatureContainer.clientHeight : 150
    }
    const getOrientation = () => {
      return (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation
    }
    const width = getWidth()
    const height = getHeight()
    signatureCanvas.setAttribute('width', width)
    signatureCanvas.setAttribute('height', height)
    signaturePad = new SignaturePad(signatureCanvas)

    const orientation = getOrientation()
    if (is.checkVariable(orientation)) {
      screen.orientation.addEventListener('change', () => {
        const width = getWidth()
        const height = getHeight()
        signatureCanvas.setAttribute('width', width)
        signatureCanvas.setAttribute('height', height)

        if (!signaturePad.isEmpty()) {
          signaturePad.clear()
        }
      }, options)
    }

    buttonClearSignature.addEventListener('click', function() {
      try {
        if (!signaturePad.isEmpty()) {
          signaturePad.clear()
        }
      } catch (err) {
        is.captureException(err)
      }

      return false
    }, options)

    buttonSendSignature.addEventListener('click', async (e) => {
      const trigger = e.delegateTarget || e.currentTarget
      if (!signaturePad.isEmpty()) {
        const width = getWidth()
        const height = getHeight()
        const file = await is.asyncTakeCareOfCompressingOnly(is.dataURLtoFile(signaturePad.toDataURL(), 'image'), width, height)
        if (!is.file(file)) {
          return false
        }

        const action = is.getAttributeValue(trigger, 'action')
        const origen = is.getAttributeValue(trigger, 'origen')
        const form = is.objectToFormData({ origen, signature: file })

        axios.post(action, form).then((response) => {
          if (response.data.success) {
            new Swal({
              text: 'Datos enviados correctamente.',
              allowOutsideClick: false,
              showConfirmButton: false,
              showCancelButton: false,
              position: 'top-start',
              icon: 'success',
              timer: 1500,
            }).finalize(() => {
              window.location.href = is.getAttributeValue(trigger, 'redirect')
            })
          }
        }).catch(response => {
          console.error(response)
          is.captureException(response)
        })
      } else {
        new Swal({
          text: 'Debe dibujar su firma en el panel indicado.',
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          position: 'top-start',
          icon: 'warning',
          timer: 1500,
        }).fire()
      }

      return false
    }, options)

    listen('#button_rejected_signature', 'click', function(e) {
      const trigger = e.delegateTarget || e.currentTarget
      const action = is.getAttributeValue(trigger, 'action')
      const id = is.getAttributeValue(trigger, 'id')
      const form = is.objectToFormData({ id })
      const promise = Swal.axiosPost(form, action)
      promise.then(() => {
        new Swal({
          text: 'Solicitud procesada correctamente.',
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          position: 'top-start',
          icon: 'success',
          timer: 1500,
        }).finalize(() => {
          window.location.href = is.getAttributeValue(trigger, 'redirect')
        })
      }).catch(error => {
        is.captureException(error)
      })
    })
  }
} catch(err) {
  console.error(err)
  is.captureException(err)
}
